module.exports = __webpack_public_path__ + "static/media/ranked_ballot_1.d5d30f5f.png";